var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "van-popup",
    {
      staticClass: "popupCommentStyle",
      style: { height: "70%" },
      attrs: {
        closeable: "",
        "get-container": "body",
        "lock-scroll": false,
        position: "bottom",
      },
      model: {
        value: _vm.commentShow,
        callback: function ($$v) {
          _vm.commentShow = $$v
        },
        expression: "commentShow",
      },
    },
    [
      _c("van-overlay", {
        attrs: { show: _vm.overlayShow, "z-index": "9999" },
        on: {
          click: function ($event) {
            _vm.show = false
          },
        },
      }),
      _c(
        "div",
        { staticClass: "popupCommentTitle font-28 cor-33 p-24 text-center" },
        [_vm._v("评论")]
      ),
      _c(
        "div",
        { staticClass: "popupCommentBox rela" },
        [
          _c(
            "div",
            { staticClass: "p-b-90 popupCommentListBox" },
            _vm._l(_vm.commentList, function (commentItem) {
              return _c(
                "div",
                {
                  key: commentItem.commentId,
                  staticClass: "flex col-top p-t-24 p-l-24 p-r-24",
                },
                [
                  _c("div", { staticClass: "w-60 h-62 m-r-16" }, [
                    _c("img", {
                      staticClass: "width-100 height-100",
                      attrs: {
                        src: require("@/assets/icon/feedbackStatistics/avatarNon.png"),
                        alt: "项目",
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-1" }, [
                    _c("div", { staticClass: "font-24 cor-99" }, [
                      _vm._v(_vm._s(commentItem.createName)),
                    ]),
                    _c("div", { staticClass: "font-28 cor-33 p-t-8 p-b-8" }, [
                      _vm._v(_vm._s(commentItem.message)),
                    ]),
                    _c("div", { staticClass: "font-24 cor-99" }, [
                      _vm._v(_vm._s(commentItem.createTime)),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _c(
            "van-cell-group",
            {
              staticClass:
                "flex row-center col-center abso pos-b-0 width-100 p-l-24 p-r-24",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "font-28 w-60 h-56 l-h-54 text-center userClickBtn b-r-100",
                  on: {
                    click: function ($event) {
                      _vm.deptUserTreeAll.show = true
                    },
                  },
                },
                [_vm._v("@")]
              ),
              _c(
                "van-popup",
                {
                  attrs: { "get-container": "body", position: "bottom" },
                  model: {
                    value: _vm.deptUserTreeAll.show,
                    callback: function ($$v) {
                      _vm.$set(_vm.deptUserTreeAll, "show", $$v)
                    },
                    expression: "deptUserTreeAll.show",
                  },
                },
                [
                  _c("van-nav-bar", {
                    attrs: {
                      "left-text": "取消",
                      "right-text": "确定",
                      title: "选择人员",
                    },
                    on: {
                      "click-left": function ($event) {
                        _vm.deptUserTreeAll.show = false
                      },
                      "click-right": _vm.commentPopupSubmit,
                    },
                  }),
                  _c("van-search", {
                    attrs: { clearable: "", shape: "round" },
                    on: {
                      input: function ($event) {
                        return _vm.treeSearch($event, _vm.$refs.tree)
                      },
                    },
                    model: {
                      value: _vm.deptUserTreeAll.filterText,
                      callback: function ($$v) {
                        _vm.$set(_vm.deptUserTreeAll, "filterText", $$v)
                      },
                      expression: "deptUserTreeAll.filterText",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "h-vh-50",
                      staticStyle: { "overflow-y": "auto" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "p-10" },
                        [
                          _c("el-tree", {
                            ref: "tree",
                            attrs: {
                              data: _vm.deptUserTreeAll.data,
                              "filter-node-method": _vm.filterNode,
                              "check-on-click-node": "",
                              "check-strictly": "",
                              "node-key": "uuid",
                              "show-checkbox": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("van-field", {
                staticClass: "p-l-26 p-r-0 p-t-20 p-b-20",
                attrs: {
                  border: true,
                  center: "",
                  clearable: "",
                  type: "textarea",
                  autosize: "",
                  placeholder: "请输入评论内容",
                },
                on: { input: _vm.handleInput },
                scopedSlots: _vm._u([
                  {
                    key: "button",
                    fn: function () {
                      return [
                        _c(
                          "van-button",
                          {
                            attrs: {
                              size: "small",
                              icon: "comment-o",
                              round: "",
                              type: "primary",
                            },
                            on: { click: _vm.sendComment },
                          },
                          [_vm._v("发送 ")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.commentForm.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.commentForm, "message", $$v)
                  },
                  expression: "commentForm.message",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }